import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ProfileHubSettingsDialogService } from '@main-client/src/app/profile/profile-hub-settings-dialog/profile-hub-settings-dialog.service';

import {
  Account,
  AccountGroupMembership,
  AccountSegmentSelection,
} from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';
import { getSegmentationSelection } from '@libs/src/segment-selections/segment-selections.helper';
import { Profile } from '@main-client/src/app/profile/profile';

import get from 'lodash-es/get';

@Component({
  selector: 'app-profile-group-item',
  templateUrl: './profile-group-item.component.html',
})
export class ProfileGroupItemComponent {
  @Input() group: Group;
  @Input() isUser: boolean;
  @Input() membership: AccountGroupMembership;
  @Input() pendingMembership: AccountGroupMembership;
  @Input() profile: Profile;
  @Input() user: Account;
  @Output() pendingHub = new EventEmitter();

  constructor(public hubSettingsDialog: ProfileHubSettingsDialogService) {}

  getSegmentSelection(segmentId: string): AccountSegmentSelection {
    return getSegmentationSelection(
      get(this.membership || this.pendingMembership, 'segment_selections', []),
      { _id: segmentId },
    );
  }

  openHubSettingsDialog() {
    return this.hubSettingsDialog.openDialog({
      user: this.user,
      profile: this.profile,
      group: this.group,
      membership: this.membership || this.pendingMembership,
      isIntroOnly: false,
    });
  }

  openPendingHubDialog(
    pendingGroup: Group,
    pendingMembership: AccountGroupMembership,
  ) {
    this.pendingHub.emit({
      pendingGroup,
      pendingMembership,
    });
  }
}
